module.exports = __webpack_public_path__ + "img/mexico.1720743e.png";